module.exports = __webpack_public_path__ + "static/media/home.6b1d7b92.jpg";